<template>
  <SiruiSearch
    ref="contractApprovalFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules } from './index.js';
  export default {
    name: 'BillApprovalForm',
    data() {
      return {
        baseFormData: {},
      };
    },
    computed: {
      formColumn() {
        return baseFormColumn(this);
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    methods: {
      // 获取表格数据
      async getTableData() {
        return await this.$refs.contractApprovalFormRef.getValidateFormData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-select {
    width: 250px;
  }
  .el-input {
    width: 250px;
  }
</style>
